import { render, staticRenderFns } from "./addIntegralRule.vue?vue&type=template&id=6dd79a85"
import script from "./addIntegralRule.vue?vue&type=script&lang=js"
export * from "./addIntegralRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports